import { render, staticRenderFns } from "./AdminUpdateDDAT.vue?vue&type=template&id=54064020&scoped=true"
import script from "./AdminUpdateDDAT.vue?vue&type=script&lang=js"
export * from "./AdminUpdateDDAT.vue?vue&type=script&lang=js"
import style0 from "./AdminUpdateDDAT.vue?vue&type=style&index=0&id=54064020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54064020",
  null
  
)

export default component.exports